module.exports = __webpack_public_path__ + "static/bg_houston-e3a9f82f111bb3f41d304973a1945fe5.jpg";